import React, { createContext, useContext } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    const token = localStorage.getItem('token');
    const socketState = useWebSocket({ token });

    return (
        <WebSocketContext.Provider value={socketState}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useSocket = () => useContext(WebSocketContext);
